// extracted by mini-css-extract-plugin
export var pillWrapper = "_oi-0";
export var showOverflow = "_oi-1";